// extracted by mini-css-extract-plugin
export default {"lineButtons":"realEstateItem_lineButtons__LLOA8","headers":"realEstateItem_headers__6O65j","twoInLine":"realEstateItem_twoInLine__jLkLv"};